<section id="ImpactEcosystemSection" class="impact-eco-section position-relative overflow-hidden py-5">
   
    <div class="container py-4">

      <!-- TOP KICKER -->
      <div class="d-flex justify-content-center align-items-center gap-3 text-uppercase text-xs fw-semibold impact-eco-kicker mb-3">
        <span class="impact-eco-kicker-line"></span>
        <span>{{ impact_data.kicker }}</span>
        <span class="impact-eco-kicker-line"></span>
      </div>

      <!-- TITLE -->
      <h2 class="impact-eco-title text-center mb-3">
        {{ impact_data.title }}
      </h2>

      <!-- SUBTEXT -->
      <p class="impact-eco-lead text-center mx-auto mb-5">
        {{ impact_data.description }}
      </p>

      <!-- TIMELINE -->
      <div class="position-relative pt-4 pb-3">
        <div class="impact-eco-line d-none d-lg-block"></div>

        <div class="row g-4 justify-content-center">
          <div
            v-for="(step, idx) in impact_steps"
            :key="step.key"
            class="col-12 col-md-6 col-lg-3"
          >
            <div class="text-center h-100 impact-eco-step">

              <!-- CIRCLE -->
              <div class="impact-eco-circle-wrap mx-auto mb-4">
                <div class="impact-eco-circle">
                  <span class="impact-eco-circle-text">{{ step.number }}</span>
                </div>
              </div>

              <!-- HEADING -->
              <h5 class="impact-eco-step-title mb-2">
                {{ step.title }}
              </h5>

              <!-- TEXT -->
              <p class="impact-eco-step-text mb-0">
                {{ step.text }}
              </p>

            </div>
          </div>
        </div>
      </div>
      <!-- /TIMELINE -->

    </div>
</section>
